module.exports = __webpack_public_path__ + "static/media/UploadIcon.a554087a.svg";